<template>
  <div class="header header-fixed">
    <!-- <nprogress-container></nprogress-container> -->
    <div
      class="container-fluid d-flex align-items-stretch justify-content-between"
    >
      <div class="header-menu-wrapper header-menu-wrapper-left"></div>
      <!-- begin: Header Menu -->
      <!-- <button class="header-menu-wrapper-close" id="kt_header_menu_mobile_close_btn"><i class="la la-close"></i></button>
		<div class="header-menu-wrapper" id="kt_header_menu_wrapper">
		</div> -->
      <!-- end: Header Menu -->
      <!-- begin:: Header Topbar -->
      <div class="topbar">
        <!--begin: User Bar -->
        <div class="topbar-item">
           <div class="dropdown">
              <!--begin::Toggle-->
              <div class="btn btn-icon btn-light-success w-auto btn-clean d-inline-flex align-items-center btn-lg px-2" data-toggle="dropdown" data-offset="0px,0px" aria-expanded="true">
                  <span class="text-muted font-weight-bold font-size-base mr-1  btn-dropdown">{{$t('hi')}},</span>
                  <span v-if="account_type == 'admin'" class="text-dark-50 font-weight-bolder font-size-base mr-3  btn-dropdown">{{ adminName }}</span>
                  <span class="text-dark-50 font-weight-bolder font-size-base mr-3  btn-dropdown">{{ FullName | capitalizeString }}</span>
                  <span class="symbol symbol-35 symbol-light-success">
                      <span class="symbol-label font-size-h5 font-weight-bold  btn-dropdown">{{firstCharacter}}</span>
                  </span>
              </div>
              <!--end::Toggle-->
              <!--begin::Dropdown-->

              <div class="dropdown-menu p-0 m-0 dropdown-menu-right dropdown-menu-anim-up dropdown-menu-lg p-0 accountDetails"  x-placement="bottom-end">
                  <!--begin::Header-->
                  <div v-if="['admin'].includes(this.$store.getters.role)">
                     
                  <div class="d-flex align-items-center p-8 rounded-top">
                      <!--begin::Symbol-->
                      <span class="symbol symbol-35 symbol-light-success">
                          <span class="symbol-label font-size-h5 font-weight-bold">{{firstCharacter}}</span>
                      </span>
                      <!--end::Symbol-->
                      <!--begin::Text-->
                      <div v-if="account_type == 'admin'" class="text-dark m-0 flex-grow-1 ml-3  mr-3 font-size-h5">{{adminName}}</div>
                      <div class="text-dark m-0 flex-grow-1 ml-3  mr-3 font-size-h5">{{FirstName | capitalizeString}}</div>
                      <!--end::Text-->
                  </div>
                      
                  </div>

                  <div class="separator separator-solid custom-separator"></div>
                  <!--end::Header-->
                  <!--begin::Nav-->
                  <div class="navi navi-spacer-x-0 pt-5">
                      <!--begin::Item-->
                      <div class="navi-footer px-8 py-5 float-right">
                          <button @click="logout" class="btn btn-sm btn-primary font-weight-bolder py-2 px-5">{{$t('sign_out')}}</button>
                      </div>
                      <!--end::Footer-->
                  </div>
                  <!--end::Nav-->
              </div>
              <!--end::Dropdown-->
          </div>
        </div>
        <!--end: User Bar -->
      </div>
    </div>
    <!-- end:: Header Topbar -->
  </div>
</template>

<script>
import notificationsComponent from "@/js/ordercircle/brands/notifications/notification-list.vue";
// import NprogressContainer from 'vue-nprogress/src/NprogressContainer'
import UserAPIService from '@/js/api/users/users';
import LoginAPIService from '@/js/api/auth/auth';


export default {
  name: "topbar",
  components: {
    notificationsComponent,
    // NprogressContainer,
    },
  mounted(){
		this.getAccountDetail();
    },
	computed: {
	  FullName () {
	    	return this.FirstName + this.LastName;
		},
		firstCharacter(){
      if(this.FirstName != null && this.account_type != 'admin'){
          return this.FirstName.charAt(0).toUpperCase();
      }
      else{
          return this.adminName.charAt(0).toUpperCase();
      }
		}
	},
	data(){
		return {
			FirstName:'',
			LastName:'',
            adminName: '',
            account_type: '',
            isSignupCompleted : false,
		}
    }, 
  methods: {
    // logout() {
    //   window.localStorage.removeItem('kt-datatable-1-meta','access_token');
    //   window.location.href = '/logout';
    // },
    logout(){
        this.$store.commit('SHOW_LOADER',true);
        LoginAPIService.getLogout().then((response) => {
          this.$store.dispatch('reset').then(response => {
          this.$store.commit('SHOW_LOADER',false);
          this.$router.push("/");
          })
        }).catch((error) => {
          this.$store.commit('SHOW_LOADER',false);
          this.notify("Error!", "Error", "error");
        })
        },
    getAccountDetail(e){
      let self = this
			UserAPIService.getAccountDetail(this.access_token).then((response) => {
					if( response.data.account_type == 'primary' || response.data.account_type == 'secondary' || response.data.account_type == 'admin')
					{
            if(typeof response.data.settings.name != "undefined")
            {
                this.FirstName = response.data.settings.name;
            }
            this.account_type = response.data.account_type;
            this.adminName = response.data.settings.username;
					}
			}).catch((error) => {
                 this.notify("Error Exception!",error, "error");
      });
		},
  },
};
</script>
<style scoped>
.btn.btn-light-success {
  color: #1bc5bd !important;
  background-color: #c9f7f5 !important;
  border-color: transparent !important;
}
    .btn.btn-light-success.focus:not(.btn-text), .btn.btn-light-success:focus:not(.btn-text), .btn.btn-light-success:hover:not(.btn-text):not(:disabled):not(.disabled) {
        color: #fff;
        background-color: #1bc5bd !important;
        border-color: transparent;
    }
    .text-mute {
    color: #b5b5c3 !important;
    }
    .topbar .topbar-item .btn.btn-icon .text-dark-50 {
        color: #7E8299 !important;
    }
    .symbol.symbol-light-success .symbol-label{
    background-color: #c9f7f5; 
    color: #1bc5bd;
    }
    .symbol.symbol-light-success .symbol-label:hover{
        background-color:  #c9f7f5 !important;
    }
@media (min-width: 992px) {
    .header {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      justify-content: space-between;
      height: 65px;
      background-color: #ffffff;
      position: relative;
      z-index: 2; }
      .header.header-fixed {
        height: 65px;
        position: fixed;
        top: 0;
        right: 0;
        left: 0;
        z-index: 97; }
      .aside-enabled .header.header-fixed {
        left: 0px; 
      }
      
      .header-fixed.subheader-fixed .header {
        -webkit-box-shadow: none !important;
        box-shadow: none !important; } 
       
      }
      

</style>
